import axios from "axios"
export default{
    VehicleInventory:{
        async Table(data){
            const response = await axios.post('/api/documentoperations/vehicleinventory/table',data)
            return response  
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/documentoperations/vehicleinventory/update' : '/api/documentoperations/vehicleinventory/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/documentoperations/vehicleinventory/delete/${data}`)
            return response
        },
        async List(){
            const response = await axios.get('/api/documentoperations/vehicleinventory/select/list')
            return response
        }
    },
    EmployeeDocument:{
        async Table(data){
            const response = await axios.post('/api/documentoperations/employee/table',data)
            return response  
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/documentoperations/employee/update' : '/api/documentoperations/employee/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/documentoperations/employee/delete/${data}`)
            return response
        },
        async List(){
            const response = await axios.get('/api/documentoperations/employee/select/list')
            return response
        }
    }
}